import React, { useCallback, useRef, useEffect } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { Typeahead, TypeaheadMenu } from "react-bootstrap-typeahead";
import "./styles.scss";

const InputAutocomplete = ({
  options,
  disabled,
  readonly,
  id,
  classes,
  onChange,
  input,
  onBlur,
  onFocus,
  value,
  maxLength,
}) => {
  const autocompleteRef = useRef(null);

  useEffect(() => {
    if (
      !input.value &&
      autocompleteRef.current &&
      autocompleteRef.current.state.text
    ) {
      autocompleteRef.current.clear();
    } else if (autocompleteRef.current) {
      const updateValues =
        autocompleteRef.current && autocompleteRef.current.state.isFocused
          ? { text: input.value, selected: [] }
          : { text: input.value, selected: [], showMenu: false };
      autocompleteRef.current.setState(updateValues);
    }
  }, [input.value]);

  const onInputBlur = useCallback(
    event => {
      const onBlurFn = input?.onBlur || onBlur;
      onBlurFn?.(input ? input.value : value);
    },
    [input, onBlur]
  );
  const onInputFocus = useCallback(
    event => {
      const onFocusFn = input?.onFocus || onFocus;
      onFocusFn?.();
    },
    [input, onFocus]
  );
  const onInputChange = useCallback(
    value => {
      const onChangeFn = input?.onChange || onChange;
      if (Array.isArray(value)) {
        value.length && onChangeFn?.(value[0]);
      } else onChangeFn?.(value);
    },
    [input, onChange]
  );
  return (
    <Typeahead
      ref={autocompleteRef}
      id={id}
      labelKey={id}
      onChange={onInputChange}
      options={options}
      onInputChange={onInputChange}
      onBlur={onInputBlur}
      onFocus={onInputFocus}
      className={classNames("mydpd-input-autocomplete", classes)}
      disabled={disabled}
      inputProps={{
        id,
        readOnly: readonly,
        maxLength,
      }}
      renderMenu={(results, menuProps) => {
        if (!results.length) {
          return null;
        }
        return <TypeaheadMenu {...menuProps} options={results} />;
      }}
    />
  );
};

InputAutocomplete.defaultProps = {
  options: [],
};

InputAutocomplete.propTypes = {
  options: PropTypes.array,
  onChange: PropTypes.func,
  id: PropTypes.string,
  disabled: PropTypes.bool,
  classes: PropTypes.object,
  input: PropTypes.object,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  value: PropTypes.string,
  readonly: PropTypes.bool,
  maxLength: PropTypes.number,
};

export default InputAutocomplete;
